<template>
  <el-form-item label="选择模板" label-width="80">
    <el-select
        clearable
        v-model="prop.styleTemplate"
        placeholder="请选择"
        @change="styleChange"
    >
      <template v-for="(op,key) in STYLR_TEMPLATE" :key="key">
        <el-option
            :label="op.templateName"
            :value="key"
        />
      </template>
    </el-select>
  </el-form-item>
</template>
<script setup>
import {STYLR_TEMPLATE} from "@/option/common/dict";
import {merge} from 'lodash-es'

let props = defineProps({
  prop: {},
  main: {}
})

function styleChange(v) {
  let targetStyle = STYLR_TEMPLATE[v];
  let options = targetStyle[props?.main?.activeObj?.component?.prop]?.option
  if (options) {
    merge(props.prop, options)
  }
}
</script>
<style scoped>

</style>